type OsType = 'Linux' | 'Android' | 'Windows' | 'iOS' | 'MacOS' | 'unknown';

export const getOS = (): OsType => {
  if (navigator.userAgent.match(/Linux/i)) {
    return 'Linux';
  }
  if (navigator.userAgent.match(/Android/i)) {
    return 'Android';
  }
  if (navigator.userAgent.match(/Windows/i)) {
    return 'Windows';
  }
  if (navigator.userAgent.match(/Mac/i)) {
    if (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      'ontouchend' in document
    ) {
      return 'iOS';
    }
    return 'MacOS';
  }
  return 'unknown';
};
